import React from "react";
import MotivosBaseTemplate from "../motivos/shared/MotivosBaseTemplate";
import {
  alterarStatusTipoOperacao,
  cadastrarTipoOperacao,
  editarTipoOperacao,
  excluirTipoOperacao,
  listarTiposOperacao,
} from "./tiposOperacao.api";

export default function TiposOperacaoBase() {
  return (
    <MotivosBaseTemplate
      titulo="Tipos de Operação"
      descricao="Cadastre os tipos de operação usados nas interdições de LOCOMOTIVAS e VAGÕES do CIM."
      placeholder="Ex.: LÍDER"
      hint="Use esta base para centralizar os tipos de operação do CIM."
      listFn={listarTiposOperacao}
      createFn={cadastrarTipoOperacao}
      updateFn={editarTipoOperacao}
      deleteFn={excluirTipoOperacao}
      toggleFn={alterarStatusTipoOperacao}
    />
  );
}
